module.exports = __webpack_public_path__ + "img/sozialschnellgut_1_a.4b6e03b4.jpg";